import { calculateWorldTourSeasonRecords } from "model/Records old/WorldTourSeasonRecord";
import { HeaderRow, HighlightTh, Table } from "../../styles";
import { SetSeasonTableRow } from "./WorldTourSeasonTableRow";
import { Match } from "model/Match/Match";

interface Props {
  matches: Match[];
  rosterIds: string[];
  tournamentId: string;
}

export const SetSeasonTable = ({ matches, rosterIds, tournamentId }: Props) => {
  const records = calculateWorldTourSeasonRecords(rosterIds, matches);
  return (
    <Table>
      <HeaderRow>
        <th colSpan={3} />
        <HighlightTh title="Match Record">W - L</HighlightTh>
        <th title="Track Record">TRK</th>
        <th title="Track Differential">TΔ</th>
        <th title="Round Points">RND</th>
        <th title="Round Differential">RΔ</th>
      </HeaderRow>
      {records.map((r) => (
        <SetSeasonTableRow
          key={r.rosterId}
          record={r}
          tournamentId={tournamentId}
        />
      ))}
    </Table>
  );
};
